import {TextField} from '@material-ui/core';
import React from 'react';

const GuiTextField = (props) => {
  return (
    <div>
      <TextField {...props} />
    </div>
  );
};

export default GuiTextField;
